// extracted by mini-css-extract-plugin
export var splitsData = "styles-module__splitsData___UNr1J";
export var dataHeadings = "styles-module__dataHeadings___G77cA";
export var splitsPace = "styles-module__splitsPace___x6rhx";
export var splitsBar = "styles-module__splitsBar___kLCcz";